"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _layout = require("@berlitz/globals/lib/components/layout");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _featureCard = _interopRequireDefault(require("@berlitz/feature-card"));
var _button = _interopRequireDefault(require("@berlitz/button"));
var _style = require("./style");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BlockFeatureCard = function BlockFeatureCard(_ref) {
  var backgroundColor = _ref.backgroundColor,
    button = _ref.button,
    column = _ref.column,
    content = _ref.content,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    imageAlt = _ref.imageAlt,
    imageMobile = _ref.imageMobile,
    imageSrc = _ref.imageSrc,
    reverse = _ref.reverse,
    size = _ref.size,
    subtitle = _ref.subtitle,
    title = _ref.title,
    youtubeVideoId = _ref.youtubeVideoId;
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 10
  }, /*#__PURE__*/_react.default.createElement(_featureCard.default, {
    column: column,
    image: imageSrc,
    imageAltText: imageAlt,
    imageLink: (button === null || button === void 0 ? void 0 : button.href) || null,
    imageTarget: (button === null || button === void 0 ? void 0 : button.target) || null,
    imageMobile: imageMobile,
    reverse: reverse,
    title: title,
    youtubeVideoId: youtubeVideoId
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, null, title), subtitle && /*#__PURE__*/_react.default.createElement(_typography.P, null, subtitle), content && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_typography.RichText, {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "lg"
  })), button.text && (button.href || button.onClick || button.to) && /*#__PURE__*/_react.default.createElement(_style.ButtonSpacer, null, /*#__PURE__*/_react.default.createElement(_button.default, button, button.text)))))));
};
BlockFeatureCard.defaultProps = {
  backgroundColor: null,
  size: 'lg',
  button: {
    as: 'a',
    href: null,
    onClick: null,
    target: null,
    text: null,
    to: null
  }
};
var _default = BlockFeatureCard;
exports.default = _default;